export interface CreateQuoteRequest {
  content: string;
  author: string | null;
  source: string | null;
  tags: string[];
}

const QUOTES_API_URL = "/api/Quotes";

export async function createQuote(request: CreateQuoteRequest) {
  const response = await fetch(QUOTES_API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    throw new Error(`Request failed with ${response.status}`);
  }
}
